/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RowSelectionModeConstants } from './RowSelectionModeConstants';
import {
    RowSelectionModeConstantsFromJSON,
    RowSelectionModeConstantsFromJSONTyped,
    RowSelectionModeConstantsToJSON,
} from './RowSelectionModeConstants';
import type { RowSelectionReadOnlyInfo } from './RowSelectionReadOnlyInfo';
import {
    RowSelectionReadOnlyInfoFromJSON,
    RowSelectionReadOnlyInfoFromJSONTyped,
    RowSelectionReadOnlyInfoToJSON,
} from './RowSelectionReadOnlyInfo';

/**
 * 
 * @export
 * @interface RowSelection
 */
export interface RowSelection {
    /**
     * 
     * @type {RowSelectionModeConstants}
     * @memberof RowSelection
     */
    mode: RowSelectionModeConstants;
    /**
     * 
     * @type {RowSelectionReadOnlyInfo}
     * @memberof RowSelection
     */
    readOnlyInfo?: RowSelectionReadOnlyInfo;
    /**
     * 
     * @type {Array<string>}
     * @memberof RowSelection
     */
    rowIds: Array<string>;
}

/**
 * Check if a given object implements the RowSelection interface.
 */
export function instanceOfRowSelection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mode" in value;
    isInstance = isInstance && "rowIds" in value;

    return isInstance;
}

export function RowSelectionFromJSON(json: any): RowSelection {
    return RowSelectionFromJSONTyped(json, false);
}

export function RowSelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowSelection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mode': RowSelectionModeConstantsFromJSON(json['mode']),
        'readOnlyInfo': !exists(json, 'readOnlyInfo') ? undefined : RowSelectionReadOnlyInfoFromJSON(json['readOnlyInfo']),
        'rowIds': json['rowIds'],
    };
}

export function RowSelectionToJSON(value?: RowSelection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mode': RowSelectionModeConstantsToJSON(value.mode),
        'readOnlyInfo': RowSelectionReadOnlyInfoToJSON(value.readOnlyInfo),
        'rowIds': value.rowIds,
    };
}

